module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/cocktail@3x_212245.jpg";